import apiService from '@/services'

export const init = { // Initialization module, containg common elements like entity common statuses
  namespaced: true,
  state: {
    statuses: {},
    interventionAreas: [],
    campaignStatus: [],
    clientStatus: [],
    merchantStatus: [],
    npoStatus: [],
    npoRegistrationStatuses: [],
    relations: [],
    initialized: false
  },
  actions: {
    loadStatuses ({ commit }) {
      const entities = ['campaigns', 'clients', 'merchants', 'npos']
      for (const entity in entities) {
        apiService
          .getStatuses(entities[entity])
          .then(data => {
            const statuses = data.map(i => {
              switch (i.status_value) {
                case 0:
                  i.color = 'gray'
                  break
                case 1:
                  i.color = 'green'
                  break
                case 2:
                  i.color = 'red'
                  break
                default:
                  i.color = 'gray'
              }
              return i
            })
            commit('setStatuses', { entity: entities[entity], statuses: statuses })
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    loadInterventionAreas ({ commit }) {
      apiService
        .getInterventionAreas()
        .then(data => {
          commit('setInterventionAreas', data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    loadNpoRegistrationStatutes ({ commit }) {
      apiService
        .getNpoRegistrationStatuses()
        .then(data => {
          commit('setNpoRegistrationStatuses', data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    loadMerchantClientRelations ({ commit }) {
      apiService
        .getMerchantRelations()
        .then(response => {
          commit('setRelations', response)
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mutations: {
    setStatuses (state, payload) {
      state.statuses[payload.entity] = payload.statuses
      state.initialized = true
    },
    setRelations (state, relations) {
      state.relations = relations
    },
    setInterventionAreas (state, interventionAreas) {
      state.interventionAreas = interventionAreas
    },
    setNpoRegistrationStatuses (state, npoRegistrationStatuses) {
      state.npoRegistrationStatuses = npoRegistrationStatuses
    }
  }

}
